import { render } from "./HomePage.vue?vue&type=template&id=52b6427c&ts=true"
import script from "./HomePage.ts?vue&type=script&lang=ts&external"
export * from "./HomePage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__